(function (appComponents) {

	appComponents.services.motorsModel = function (Components) {

		var motorsModel = {};

		motorsModel.name = "motorsModel";


		Components.getComponentPrototype().extend(motorsModel);

		motorsModel._b2bUnit = motorsModel._getService("b2bUnit");
		motorsModel._modals = motorsModel._getService("modals");

		motorsModel.bindings = function () {
			$(document).on("click", "[pc-container='motors-model--go-to-configure']", function () {
				var type = $(this).attr("pc-value");
				motorsModel.handlers.onGoToConfigure(type);
			});
		};

		motorsModel.handlers = {
			onGoToConfigure: function (type) {
				if (motorsModel._b2bUnit.isUnitSet && motorsModel._b2bUnit.unitType == "ORACLE") {
					var url = (type == "single") ? motorsModel._links.motorsModelSearch : motorsModel._linkgs.motorsModelSearchMultiple;
					var ssoID="";
					if(motorsModel._config.user.id)
					{
					var sso_RM=motorsModel._config.user.id;
					ssoID=sso_RM.substring(3);
					}
					url=url+"?sm_ssoid="+ssoID;
					motorsModel._goToPath(url);
				} else {
					motorsModel._modals.warning.showHtml(motorsModel._messages.unitTypeIsNotAllowed);
				}
			}
		};

		motorsModel.init = function () {
			motorsModel._bindings();
			// motorsModel._events.registerHandler("pageDataInitialized", motorsModel.name, motorsModel.handlers.onPageDataInitialized);
		};

		return motorsModel;


	};

	window.appComponents = appComponents;

})(window.appComponents || {});